// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1GIj2","form":"styles_form__VzEBk"};